import * as React from "react"
import {TabsSeeker} from "@ui-seeker/core";

import { DISPLAY_TABS } from "./@constants";
import PricingMarketAnalyzerTable from "./index";
import {useMarketAnalyzerRoleConfig} from "../../@hooks";


const TABS = [
	{label: 'Actual Price', value: 'Actual'},
	{label: 'List Price', value: 'List'}
]

const RETAILER_TABS = [
	{label: 'Current Price', value: 'Current'},
	{label: 'List Price', value: 'List'}
]

export default function PricingMarketAnalyzerTableTabs({ value, onChange }) {
	const { isRetailerUser } = useMarketAnalyzerRoleConfig()
    return <TabsSeeker
		tabs={isRetailerUser ? RETAILER_TABS : TABS}
		value={value}
		onChange={onChange}
	/>
}